export const environment = {
  production: false,
  apiUrl: 'https://test-gate-api.uims.kz/api/',
  finesUrl: 'https://test-gate-api.uims.kz/api/',
};
